import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const OrganizationPage = loadable(() => import('./OrganizationPage'));
export default {
    id: 'organisation',
    title: 'Organisation',
    icon: 'tree6',
    route: 'organisation',
    defaultRoute: 'organisation/groups',
    component: OrganizationPage,
    group: 'administration',
    subGroup: 'general',
    structure,
};
